import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconExpired } from 'src/assets/icons/icon-expired.svg';

import { useChangeEffect, useTimeout, useCustomSearchParams } from 'src/hook';
import { selectPayment, selectWidgetSettings } from 'src/store/slice/payment/state';

import PopupContent from 'src/components/popups/popupContent';
import Button from 'src/components/button/Button';

import './popup-expired-payment.scss';
import { EPaymentStatus } from 'src/type';

const PopupExpiredPayment: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const payment = useSelector(selectPayment);
  const widgetSettings = useSelector(selectWidgetSettings);

  console.log(payment, 'payment');

  const { redirect } = useCustomSearchParams();

  const [isShowPopup, setShowPopup] = useState<boolean>(false);

  /**
   * useEffect to show popup expired payment
   */
  useChangeEffect(() => {
    if (payment && payment.client_status === EPaymentStatus.Expired && payment.expiration === 0) {
      setShowPopup(true);
    }
  }, [payment]);

  useTimeout(() => {
    setShowPopup(true);
  }, payment?.expiration || null);

  const isLink = redirect || widgetSettings.redirectUrl;
  const description = isLink
    ? t('POPUP_EXPIRED_PAYMENT_DESCRIPTION.PLEASE_CLICK_BUTTON')
    : t('POPUP_EXPIRED_PAYMENT_DESCRIPTION.PLEASE_REQUEST');

  return (
    <PopupContent
      wrapperClass="popup-expired"
      visible={isShowPopup}
      title={t('POPUP_EXPIRED_PAYMENT_TITLE.PAYMENT_HAS_EXPIRED') || undefined}
    >
      <i className="popup-expired-icon">
        <IconExpired />
      </i>

      <p className="popup-expired-description">{description}</p>

      {isLink && (
        <Button
          wrapperClass="popup-expired-button"
          message={t('POPUP_EXPIRED_PAYMENT_BUTTON.BACK_TO_STORE')}
          onEvent={() => (window.location.href = redirect || widgetSettings.redirectUrl)}
        />
      )}
    </PopupContent>
  );
};

export default PopupExpiredPayment;
